module.exports = __webpack_public_path__ + "img/info-thin.af9c4bc3.svg";